import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

// REDUX ACTIONS
import { saveFormDataAXN } from '../../../../actions/formData/formDataActions';
import { saveUserInputAXN } from '../../../../actions/formData/userInputActions';
import { getUserPIIDataV2AXN } from '../../../../actions/transactionHistory/transactionHistoryActions';

// SEARCH RESULTS
import ChinaIDVerification from './results/ChinaIDVerification';
import ChinaPhone from './results/ChinaPhone';
import ChinaBankCard from './results/ChinaBankCard';
import ChinaPassportVerification from './results/ChinaPassportVerification';
import ChinaDriverLicense from './results/ChinaDriverLicense';
import GlobalWatchlistAML from '../../reusableSearch/GlobalWatchlistAML';
import ApiResults from "../../reusableComponent/ApiResults";

// VALIDATIONS
import isEmptyVAL from '../../../../validations/checks/isEmptyVAL';

// UTILITIES
import { transUTL } from '../../../../utils/transUTL';
import whitelistedInputDataCN from '../../../formOverview/countryForms/china/helpers/whitelistedInputDataCN';
import genderStringUTL from '../../../../utils/genderStringUTL';
import { dataSourcesIsCheckedUTL } from '../../../../utils/outputMasterUTL';

const ChinaResults = ({
  authRXS,
  countryRXS,
  dataSourcesRXS,
  formDataRXS,
  userInputRXS,
  apiReqRXS,
  searchVerificationRXS,
  saveFormDataAXN,
  getUserPIIDataV2AXN,
  watchlistStatus,
  handleClearResults,
  history,
}) => {
  const { chinaFormData } = formDataRXS;
  const selectedDataSources = dataSourcesIsCheckedUTL(
    dataSourcesRXS.chinaDataSources
  );

  let { serviceResponses } = searchVerificationRXS;
  if (isEmptyVAL(serviceResponses)) {
    serviceResponses = {};
  }

  const whitelistedData = whitelistedInputDataCN(
    chinaFormData,
    selectedDataSources
  );

  const {
    idVerificationConsentObtained,
    nationalPhoneConsentObtained,
    phoneAltConsentObtained,
    bankCardConsentObtained,
    passportVerificationConsentObtained,
    driversLicenseConsentObtained,
    ...displayData
  } = whitelistedData;

  displayData.gender = genderStringUTL(displayData);

  const displayDataFiltered = Object.keys(displayData)
    .map((val) => displayData[val])
    .filter((v) => !isEmptyVAL(v));

  // GENERATE PDF
  const generatePDF = () =>
    getUserPIIDataV2AXN(authRXS.user, searchVerificationRXS.reportingReference);

  return (
    <Fragment>
      <header className="header-secondary search-verification__input-data">
        <h4 className="header-title-secondary">
          <strong>{transUTL('translateSearchVerification.inputData')}</strong>{' '}
          {displayDataFiltered.join(' | ')}
        </h4>
      </header>
      {
        !isEmptyVAL(serviceResponses) && (
          <ChinaBankCard results={serviceResponses} type="China Bank Card"/>
        )
      }
      {!isEmptyVAL(serviceResponses) && (
        <ChinaPhone results={serviceResponses} type="China Phone" />
      )}

      {!isEmptyVAL(serviceResponses) && (
        <ChinaIDVerification
          results={serviceResponses}
          type="China ID Verification"
        />
      )}

      {!isEmptyVAL(serviceResponses) && (
        <ChinaPassportVerification
          results={serviceResponses}
          type="China Passport Verification"
        />
      )}

      {!isEmptyVAL(serviceResponses) && (
        <ChinaDriverLicense
          results={serviceResponses}
          type="China Driver License"
        />
      )}

      {(userInputRXS.isTickedApiDisplay) && (
        <ApiResults
          results={searchVerificationRXS}
          apiReq={apiReqRXS.apiCall}
          // type={isAuDeathCheck}
        />
      )}

      {!isEmptyVAL(serviceResponses) && (
        <GlobalWatchlistAML results={serviceResponses} type="Watchlist AML" />
      )}

      {/* BUTTONS */}
      <div className="search-verification__btns">
        <div className="btn-container btn-under">
          <button
            className="btn-primary"
            onClick={() => history.push('/form-overview')}
          >
            {transUTL('translateBtn.editSearch')}
          </button>

          <button className="btn-primary" onClick={handleClearResults}>
            {transUTL('translateBtn.newSearch')}
          </button>
        </div>

        <div className="btn-container btn-under">
          <button className="btn-primary" onClick={generatePDF}>
            {transUTL('translateBtn.generatePDF')}
          </button>

          <button className="btn-primary" onClick={() => window.print(history.push('/search-verification'))}>
            {transUTL('translateBtn.printSearchResults')}
          </button>
        </div>
      </div>
    </Fragment>
  );
};

ChinaResults.propTypes = {
  authRXS: PropTypes.object.isRequired,
  countryRXS: PropTypes.string.isRequired,
  dataSourcesRXS: PropTypes.object.isRequired,
  formDataRXS: PropTypes.object.isRequired,
  userInputRXS: PropTypes.object.isRequired,
  apiReqRXS: PropTypes.object.isRequired,
  saveFormDataAXN: PropTypes.func.isRequired,
  saveUserInputAXN: PropTypes.func.isRequired,
  searchVerificationRXS: PropTypes.object.isRequired,
  watchlistStatus: PropTypes.object.isRequired,
  handleClearResults: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  authRXS: state.authRXS,
  countryRXS: state.countryRXS,
  dataSourcesRXS: state.dataSourcesRXS,
  formDataRXS: state.formDataRXS,
  userInputRXS: state.userInputRXS,
  apiReqRXS: state.apiReqRXS,
  searchVerificationRXS: state.searchVerificationRXS,
});

export default connect(mapStateToProps, {
  saveFormDataAXN,
  saveUserInputAXN,
  getUserPIIDataV2AXN,
})(withRouter(ChinaResults));
